import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";
import { createInterviewsForCandidate } from "./interviewSlice";

const API_URL = "/api/candidates"; // Matches your backend route in server.ts

// Create Candidate (with interview creation)
export const createCandidate = createAsyncThunk(
  "candidates/createCandidate",
  async (candidateData, { dispatch }) => {
    const response = await hrmsPostRequest(API_URL, candidateData);
    
    // After creating the candidate, also create interviews for them
    await dispatch(createInterviewsForCandidate(response.data.id));
    
    return response.data;
  }
);

// Fetch Candidates
export const fetchCandidates = createAsyncThunk("candidates/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  console.log("API Response:", response.data);
  return response.data;
});

// Add Candidate (alternative to createCandidate without interview creation)
export const addCandidate = createAsyncThunk("candidates/add", async (candidateData) => {
  const response = await hrmsPostRequest(API_URL, candidateData);
  return response.data;
});

// Update Candidate
export const updateCandidate = createAsyncThunk(
  "candidates/update",
  async ({ id, updatedData }, { dispatch }) => {
    const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
    
    // If candidate is being approved, create interviews for them
    if (updatedData.candidateStatus === 'Approved') {
      console.log("Candidate approved, creating interviews...");
      await dispatch(createInterviewsForCandidate(id));
    }
    
    return response.data;
  }
);

// Delete Candidate
export const deleteCandidate = createAsyncThunk("candidates/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

const candidateSlice = createSlice({
  name: "candidates",
  initialState: {
    candidates: [],
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCandidates.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchCandidates.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.candidates = action.payload;
      })
      .addCase(fetchCandidates.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      })
      .addCase(addCandidate.fulfilled, (state, action) => {
        state.candidates.push(action.payload);
      })
      .addCase(createCandidate.fulfilled, (state, action) => {
        state.candidates.push(action.payload);
      })
      .addCase(updateCandidate.fulfilled, (state, action) => {
        const index = state.candidates.findIndex((c) => c.id === action.payload.id);
        if (index !== -1) {
          state.candidates[index] = action.payload;
        }
      })
      .addCase(deleteCandidate.fulfilled, (state, action) => {
        state.candidates = state.candidates.filter((c) => c.id !== action.payload);
      });
  },
});

export default candidateSlice.reducer;